import util from '../../utils/util';
let abtestPromise = null;
const rtcABTestUrl =
  'https://abtest.api.autohome.com.cn/route/selector.js?appKey=fqrlg-48525e40-e6af-4eac-8c82-c21c46b113d8';
export default {
  state: {
    rtcUIType: '', // ui 类型
  },
  mutations: {
    setRtcUIType: function (state, { uiType }) {
      state.rtcUIType = uiType;
    },
  },
  getters: {
    rtcUIType: (state) => state.rtcUIType,
  },
  actions: {
    getRtcUI({ commit }) {
      if (util.browser.isApp) {
        if (!abtestPromise) {
          abtestPromise = util
            .loadScript({
              src: rtcABTestUrl,
              id: 'abtest.api.route.selector.js',
            })
            .then(() => {
              const uiType = window.abTestCtx?.envVars?.rtcUI || 'a';
              commit('setRtcUIType', { uiType });
              return uiType;
            })
            .catch(() => {
              commit('setRtcUIType', { uiType: 'b' });
            });
        }
        return abtestPromise;
      } else {
        if (util.browser.isMobile) {
          commit('setRtcUIType', { uiType: 'b' });
        }
        return 'b';
      }
    },
  },
  namespaced: true,
};
